import SaveCalendarDataStore from './schema/SaveCalendarDataStore';
import { createStore } from 'satcheljs';
import { SaveCalendarViewConfig } from './schema/SaveCalendarViewConfig';
import { ObservableMap } from 'mobx';

const initialSaveCalendarDataStore: SaveCalendarDataStore = {
    savedViewMap: new ObservableMap<string, SaveCalendarViewConfig>(),
    currentlyDisplayedViewId: null,
    isLoaded: false,
};

export let getStore = createStore<SaveCalendarDataStore>(
    'SaveCalendarDataStore',
    initialSaveCalendarDataStore
);
